<div *ngIf="funnelTemplate" cdkDropList (cdkDropListDropped)="drop($event)">
    <mat-form-field class="templateNameField">
        <mat-label>{{ 'applicant-tracker.templateName' | appTranslate }}</mat-label>
        <input
            name="templateName"
            placeholder="{{ 'applicant-tracker.templateName' | appTranslate }}"
            [(ngModel)]="funnelTemplate.name"
            #funnelTemplateField="ngModel"
            required
            matInput
            type="text"
        />
        <mat-error *ngIf="funnelTemplateField.invalid">{{ funnelTemplateField.errors | formErrors }}</mat-error>
    </mat-form-field>
    <h4>{{ 'applicant-tracker.applied' | appTranslate }}</h4>
    <h3 *ngIf="!funnelStageAndMessageTemplates?.length">{{ 'applicant-tracker.noFunnelTemplates' | appTranslate }}</h3>
    <div class="scrollable padding-bottom-3">
        <div
            class="funnel-stage flex justify-space-between align-items-center padding-y-1"
            *ngFor="let funnelStageAndMessageTemplate of funnelStageAndMessageTemplates; let i = index"
            cdkDrag
            cdkDragPreviewContainer="parent"
        >
            <div class="title">
                <h5 class="font-medium margin-bottom-0 padding-left-1">
                    {{ funnelStageAndMessageTemplate.funnelTemplateStage.name }}
                </h5>
            </div>
            <div class="meatball flex align-items-center">
                <ui-badge *ngIf="funnelStageAndMessageTemplate.funnelMessageTemplate">{{
                    'applicant-tracker.components.kanban.auto-email' | appTranslate
                }}</ui-badge>

                <ui-button [matMenu]="meatball">
                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                </ui-button>
            </div>

            <!-- Mat menu -->
            <mat-menu #meatball>
                <button mat-menu-item *ngIf="temporaryDelete" (click)="onDelete(i)">
                    {{ 'delete' | appTranslate }}
                </button>
                <button
                    mat-menu-item
                    *ngIf="!temporaryDelete"
                    (click)="onDeleteFunnelStage(funnelStageAndMessageTemplate.funnelTemplateStage, i)"
                >
                    {{ 'delete' | appTranslate }}
                </button>
            </mat-menu>
        </div>
    </div>
</div>
